import React from 'react';
import { Disclaimer } from 'mm-ui-components';
import { BlockWidths } from 'mm-ui-components/dist/src/base/components/pageLayouts/BlockTypes.utils';

interface DisclaimerAtDynamicPositionProps {
  disclaimerText: string | null;
  defaultBlocksWidths: BlockWidths;
  shouldDisplayDisclaimerAtBottom: boolean;
}
export const DisclaimerAtDynamicPosition: React.FunctionComponent<DisclaimerAtDynamicPositionProps> = props => {
  const { children, disclaimerText, defaultBlocksWidths, shouldDisplayDisclaimerAtBottom } = props;
  if (!disclaimerText) {
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    );
  }
  return (
    shouldDisplayDisclaimerAtBottom ? (
      <React.Fragment>
        {children}
        <Disclaimer text={disclaimerText} defaultBlocksWidths={defaultBlocksWidths} />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Disclaimer text={disclaimerText} defaultBlocksWidths={defaultBlocksWidths} />
        {children}
      </React.Fragment>
    )
  );
};
